import React from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { FaSearch } from "react-icons/fa"; // Optional icon

const SearchBox = ({ searchTerm, onSearchChange, onSearchClick }) => {
  return (
    <Form className="mb-3">
      <InputGroup>
        <Form.Control
          type="text"
          placeholder="Search By Name..."
          value={searchTerm}
          onChange={onSearchChange}
        />
        <Button variant="primary" onClick={onSearchClick}>
          <FaSearch />
        </Button>
      </InputGroup>
    </Form>
  );
};
export default SearchBox;
